import React, { useEffect } from "react"
import Date13 from "../../../assets/images/date13.svg"
import TeamZoee from "../../../assets/images/why-zoee-landing-desktop-comp.webp"
import MailBox from "../../../assets/images//MailBox.svg"
import { ExternalBootcampRequests } from "../../../api/app.service"
import { Link } from "react-router-dom"
import { SvgZoeeLogoColored } from "../../../components/icons"
import { useToast } from "../../../hooks/useToast"

const BusinessBootcampSuccessPage = () => {
  const { toast } = useToast()
  const email = localStorage.getItem("email")
  const name = localStorage.getItem("name")

  const sendSuccessEmail = () => {
    if (email && name) {
      ExternalBootcampRequests.sendPurposeToProfitBootcampNotifications({
        email,
        first_name: name,
      })
        .catch((ex) => {
          console.error(ex)
          toast.error(
            ex.response?.data?.message ||
              "An error occurred. Please contact support@zoee.com"
          )
        })
        .finally(() => {
          localStorage.clear()
        })
    }
  }

  const downloadICS = () => {
    const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Zoee//From Purpose to Profit Bootcamp//EN
CALSCALE:GREGORIAN
METHOD:PUBLISH
BEGIN:VEVENT
UID:bootcamp-2025@zoee.com
SUMMARY:From Purpose to Profit Bootcamp
DESCRIPTION:From Purpose to Profit runs November 3–7, 2025 (live on Zoom, 12:00–1:30 PM EST, Monday–Friday). Program details and Zoom invitations will be sent to your email before November 3rd.
LOCATION:Zoom (link to be sent via email)
DTSTART;TZID=America/New_York:20251103T120000
DTEND;TZID=America/New_York:20251103T133000
RRULE:FREQ=DAILY;COUNT=5
END:VEVENT
END:VCALENDAR
    `.trim()

    const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = "From_Purpose_to_Profit_Bootcamp.ics"
    link.click()
    URL.revokeObjectURL(url)
  }

  useEffect(() => {
    sendSuccessEmail()
  }, [email, name])

  return (
    <div className="h-fit px-5 md:px-0 flex flex-col items-center">
      <div className="w-full flex flex-col justify-between items-center p-4 md:py-4 md:px-[72px] md:flex-row border-b border-[#D1D9E0]">
        <Link to="/5daybusinessbootcamp">
          <SvgZoeeLogoColored />
        </Link>
      </div>
      <div className="flex-grow w-[1000px] max-w-full mt-10">
        <div className="flex flex-col items-center py-2">
          <h1 className="text-center font-bold text-[36px]">
            Congratulations! You're enrolled in From Purpose to Profit: The
            5-Day Business Bootcamp for Coaches!
          </h1>
          <p className="text-[22px] text-center">
            Enrollment confirmation will be emailed to you by no-reply@zoee.com.
          </p>
          <img
            className="max-w-full h-auto md:w-[600px] md:h-auto md:my-8 object-contain"
            src={TeamZoee}
            alt="Team Zoee"
          />
          <p className="text-[18px] text-center max-w-full">
            Do you have questions about the program? Contact Zoee support at{" "}
            <a
              href="mailto:support@zoee.com"
              target="_blank"
              rel="noreferrer"
              className="underline break-words"
            >
              support@zoee.com
            </a>
          </p>
        </div>
        <hr className="my-10" />
        <div className="mb-[32px] md:mb-[50px]">
          <h3 className="text-center text-[36px] mb-10">
            Here’s what happens next
          </h3>
          <div className="flex gap-8 flex-wrap items-center justify-center">
            <div className="w-[484px] max-w-full mb-2">
              <div className="flex items-center gap-4 mb-4">
                <img src={Date13} alt="date 13" />
                <h4 className="text-[22px] font-bold">Mark Your Calendar!</h4>
              </div>

              <div className="flex gap-3 flex-wrap">
                <a
                  href="https://calendar.google.com/calendar/render?action=TEMPLATE&text=From+Purpose+to+Profit+Bootcamp&details=From+Purpose+to+Profit+runs+November+3–7,+2025+(live+on+Zoom,+12:00–1:30+PM+EST,+Monday–Friday).+Program+details+and+Zoom+invitations+will+be+sent+to+your+email+before+November+3rd.&dates=20251103T170000Z/20251103T183000Z&recur=RRULE:FREQ=DAILY;COUNT=5"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#4750f5] text-white px-4 py-2 rounded-md text-sm font-semibold hover:bg-[#3b43d0] transition flex items-center gap-2"
                >
                  <span aria-hidden="true">&#128197;</span>
                  <span>Add to Google Calendar</span>
                </a>

                <button
                  onClick={downloadICS}
                  className="bg-[#E5E7EB] text-[#333] px-4 py-2 rounded-md text-sm font-semibold hover:bg-[#D1D5DB] transition flex items-center gap-2"
                >
                  <span aria-hidden="true">&#128197;</span>
                  <span>Download .ICS</span>
                </button>
              </div>
            </div>

            <div className="w-[484px] max-w-full mb-2">
              <div className="flex items-center gap-4">
                <img src={MailBox} alt="mail box" />
                <h4 className="text-[22px] font-bold">Check Your Email</h4>
              </div>
              <p className="text-[18px]">
                Program details will be sent to your inbox as the start date
                nears Nov 3rd. Be sure to also check your spam.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BusinessBootcampSuccessPage
